/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
// import { retailers } from "@/services/global.services";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const baseSchema = z.object({
  // is_new: z.boolean(),
  uom: z.string().min(1, {
    message: "UOM is required.",
  }),
  erp_uom: z.string().min(1, {
    message: "Erp Uom is required.",
  }),
  customer_branches: z.array(z.any()).optional(),
  sku_code: z.any().optional(),
  conversion_rate: z.number().optional(),
  po_uom_qty: z.number().optional(),
  decimal_places: z.any().optional(),
});

const formSchema = baseSchema.superRefine((data, ctx) => {
  if (!data.customer_branches || data.customer_branches.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["retailer_id"],
      message: "At least one customer is required.",
    });
  } else if (
    data.customer_branches.some(
      (item: any) => !Array.isArray(item?.branches) || !item.branches.length,
    )
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["customer_branches"],
      message: "Branch is required for all customers.",
    });
  }
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = baseSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      customer_branches: [],
      uom: "",
      erp_uom: "",
      sku_code: [],
      conversion_rate: 1,
      po_uom_qty: 1,
      decimal_places: null,
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (key === "sku_code" && !Array.isArray(formData[key])) {
          const value = formData[key];
          console.log({ value });
          form.setValue(key, [value], {
            shouldTouch: true,
            shouldDirty: true,
          });
        } else if (key === "customer_branches" && Array.isArray(formData[key])) {
          const value = formData[key].map((item: any) => ({
            ...item,
            branches: Array.isArray(item?.branches) ? item.branches : [],
          }));
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        } else {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const payload = values;
    const { data } = await onFormSubmit(payload);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
